import { SnackbarTitleVariants } from './snackbar-title.styles'

type SnackbarTitleProps = {
  children?: React.ReactNode
}

export const SnackbarTitle = (props: SnackbarTitleProps) => {
  const { children } = props
  return (
    <p
      className={SnackbarTitleVariants({})}
      data-testid="snackbar-title"
      aria-label={children?.toString()}
    >
      {children}
    </p>
  )
}
